import mixins from 'vue-typed-mixins';

import C勘定科目TableEditRow from '@/components/勘定科目/table/editRow/勘定科目TableEditRow.vue';
import C勘定科目TableHeader from '@/components/勘定科目/table/header/勘定科目TableHeader.vue';

import 勘定科目Mixin from '@/entries/user/mixins/勘定科目Mixin';
import 勘定科目SaveMixin from '@/entries/user/mixins/勘定科目SaveMixin';
import 勘定科目ListEditMixin from '@/components/勘定科目/listEdit/勘定科目ListEditMixin';

export default mixins(勘定科目Mixin, 勘定科目ListEditMixin, 勘定科目SaveMixin).extend({
  name: 'C勘定科目ListEditDialog',

  components: {
    C勘定科目TableEditRow,
    C勘定科目TableHeader,
  },

  methods: {
    async save(): Promise<void> {
      if (await this.save勘定科目ByMixin(this.isNew勘定科目, this.e勘定科目カテゴリ, this.edit勘定科目)) return;
      this.end勘定科目Edit();
      this.$emit('saved');
    },
  },
});
